import React, {Component} from 'react';
import {Dialog, Spinner, Form, ValidatingInput} from '../widgets';
import {connect} from 'react-redux';
import {uiActions} from '../chrome';
import './LoginDialog.css';
import fetchJson, {postJson} from '../fetchJson';
import handleError from '../handleError';

const canSubmit = ({email, confirmEmail, validatedEmail, emailValidity}) =>
	email && // Has an email
	emailValidity && // and has been confirmed as valid
	email === validatedEmail && // and was actually the one we confirmed as valid
	email === confirmEmail; // and matches the confirmation email

const getEmailState = state => {
	if (state.validatingEmail) {
		// Checking validity
		return 'validating';
	}

	if (state.email && state.email.length > 0) {
		if (state.emailValidity === true) {
			// Email is definitely valid
			return 'valid';
		} else if (state.emailValidity === false) {
			// Email is definitely invalid
			return 'invalid';
		} else {
			return 'in_use'; // User is still typing
		}
	} else {
		// Nothing entered
		return 'required';
	}
};

class ChangeEmail extends Component {
	constructor() {
		super();

		this.state = {
			navigating: false,
			email: '',
			confirmEmail: '',
			validatingEmail: false,
			validatedEmail: null,
			emailValidity: null
		};

		this.changeEmail = e => this.setState({email: e.target.value});
		this.changeConfirmEmail = e => this.setState({confirmEmail: e.target.value});

		this.handleKeyPress = e => {
			if (e.key === 'Enter' && canSubmit(this.state)) {
				this.submit();
			}
		};
		this.navigated = () => {
			this.setState({navigating: true});
		};

		this.validateEmail = () => {
			if (
				this.state.email &&
				this.state.email.length &&
				this.state.validatedEmail !== this.state.email
			) {
				const email = this.state.email;
				this.setState({
					validatingEmail: true,
					emailValidated: true
				});
				fetchJson(`/api/user/email/${email}/valid`)
					.then(result => {
						this.setState({
							emailValidity: result.valid,
							validatingEmail: false,
							validatedEmail: email
						});
					})
					.catch(this.props.handleError);
			}
		};

		this.submit = () => {
			this.setState({
				navigating: true
			});

			postJson(`/api/user/${encodeURIComponent(this.state.email)}/change`, {})
				.then(() => this.props.onSubmit())
				.catch(this.props.handleError);
		};
	}

	render() {
		return (
			<Dialog
				buttons={['cancel', 'submit']}
				disabled={{submit: !canSubmit(this.state)}}
				onSubmit={this.submit}
				onCancel={this.props.onCancel}
				title={'Change email address'}
				emphasis={'submit'}>
				<div className="LoginDialog">
					<p>Please enter your new B2Me email address below:</p>

					<Form>
						<div className="LoginDialog-field">
							<label htmlFor="email">Email address</label>
							<ValidatingInput
								id="email"
								type="email"
								name="username"
								autoComplete="username"
								placeholder="e.g. fred@b2me.com.au"
								onKeyPress={this.handleKeyPress}
								onChange={this.changeEmail}
								value={this.state.email}
								onBlur={this.validateEmail}
								state={getEmailState(this.state)}
								states={{
									required: {
										message: 'Required',
										title: 'An email is mandatory for sign-up',
										icon: 'icon-warning',
										colour: '#ffc20e'
									},
									in_use: {
										message: '',
										title: ''
									},
									validating: {
										message: 'Checking...',
										title: 'Checking if this email is appropriate for use'
									},
									invalid: {
										message: '',
										title: 'This email address is invalid or taken',
										icon: 'icon-error',
										colour: 'red',
										caption: 'This email address is invalid or taken',
										captionStyle: {
											color: 'red'
										}
									},
									valid: {
										message: '',
										title: 'This email address is valid and available',
										icon: 'icon-check',
										colour: 'green'
									}
								}}
							/>
						</div>
						<div className="LoginDialog-field">
							<label htmlFor="confirm">Confirm email</label>
							<ValidatingInput
								id="confirm"
								type="email"
								name="username"
								autoComplete="username"
								placeholder="e.g. fred@b2me.com.au"
								onKeyPress={this.handleKeyPress}
								onChange={this.changeConfirmEmail}
								value={this.state.confirmEmail}
								invalidMessage="Email must match"
								isValid={
									this.state.confirmEmail &&
									this.state.email &&
									this.state.confirmEmail === this.state.email
								}
							/>
						</div>
					</Form>
					{this.state.navigating && <Spinner />}
				</div>
			</Dialog>
		);
	}
}

const ConnectedChangeEmail = connect(
	state => ({
		modal: state.ui.modal
	}),
	dispatch => ({
		handleError: () => handleError(dispatch),
		onSubmit: () => {
			dispatch(uiActions.uiModal(null));
			dispatch(
				uiActions.uiMessage(
					`A verification link has been sent to your new email address. Please open it to confirm the change.`
				)
			);
		},
		onCancel: () => dispatch(uiActions.uiModal(null))
	})
)(ChangeEmail);

export default ConnectedChangeEmail;



// WEBPACK FOOTER //
// ./src/user/ChangeEmail.js